import React from "react";
import PropTypes from "prop-types";
import { ChipFilter } from "../ChipFilter/ChipFilter";
import "./filter.css";

export const Filter = ({ 
    id,
    title,
    titleColor = '#333',
    options,
    value = [],
    onChange,
    type = "chips",
    ...rest
}) => {
    const renderFilterContent = () => {
        switch(type) {
            case "chips":
                return (
                    <ChipFilter
                        id={id}
                        options={options}
                        value={value}
                        onChange={onChange}
                        className="filters"
                    />
                );
            case "buttons":
                return (
                    <div className="button-filter">
                        {options.map((option) => (
                            <button
                                key={option.value}
                                className={`filter-button ${value.includes(option.value) ? 'active' : ''}`}
                                onClick={() => onChange(id, option.value)}
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                );
            case "range":
                const startIndex = options.steps.indexOf(value[0]) !== -1 ? options.steps.indexOf(value[0]) : 0;

                const handleChange = (e) => {
                    const newIndex = parseInt(e.target.value);
                    const newValue = options.steps[newIndex];
                    onChange(id, [newValue]);
                };

                const formatValue = (value) => {
                    if (value >= 50000) return "50,000+";
                    return value.toLocaleString();
                };

                return (
                    <div className="range-filter">
                        <input
                            type="range"
                            min={0}
                            max={options.steps.length - 1}
                            step={1}
                            value={startIndex}
                            onChange={handleChange}
                            className="range-input"
                        />
                        <div className="range-values">
                            <span>{formatValue(options.steps[0])}</span>
                            <span>{value[0] ? formatValue(value[0]) : 0}</span>
                            <span>{formatValue(options.steps[options.steps.length - 1])}</span>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="filter-container" {...rest}>
            <div className="filter-inner-container">
                <h4 className="filter-label" style={{ color: titleColor }}>{title}</h4>
                {renderFilterContent()}
            </div>
        </div>
    );
};

Filter.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    titleColor: PropTypes.string,
    type: PropTypes.oneOf(["chips", "buttons", "range"]),
    value: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.number,
        PropTypes.string
    ]),
    options: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                label: PropTypes.string.isRequired,
            })
        ),
        PropTypes.shape({
            min: PropTypes.number,
            max: PropTypes.number
        })
    ]).isRequired,
    onChange: PropTypes.func,
};